export class CorpHierarchyModel {
  label: string;
  systemName: string;
  singular: string;
  lastTouchedBy: string;
  order: number;
}
